import { cx } from '../cx'

export interface GridProps {
  className?: string
  children: React.ReactNode
}

/**
 * @deprecated
 */
export function Grid({ children, className, ...props }: GridProps) {
  return (
    <div className={cx('fluid-grid fluid-container', className)} {...props}>
      {children}
    </div>
  )
}
